// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ****Fonts**** */
/* ****Shadows (subtle elevation — flat SaaS)**** */
/* ****Border radius**** */
/* ****icon size**** */
/* **** Device width **** */
/* **** helper variable **** */
/* **** Motion **** */
.Sidebar_sidebar__cTjr2 {
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-direction: column;
  background-color: var(--card-bgc);
  color: var(--text-color);
  width: 248px;
  height: 100vh;
  position: fixed;
  top: 0;
  border-right: 1px solid var(--border-color);
  transition: width 200ms cubic-bezier(0.16, 1, 0.3, 1), transform 200ms cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 200;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1.25rem 0.75rem;
}
.Sidebar_sidebar__cTjr2.Sidebar_sidebar_close__VY5Y6 {
  width: 72px;
}
@media only screen and (max-width: 768px) {
  .Sidebar_sidebar__cTjr2.Sidebar_sidebar_close__VY5Y6 {
    width: 100%;
  }
}
@media only screen and (max-width: 768px) {
  .Sidebar_sidebar__cTjr2 {
    width: 100vw;
    z-index: 1;
    background-color: var(--secondaryColor);
    color: #f8fafc;
    border-right: none;
  }
}
.Sidebar_sidebar__logo__qXaKw {
  text-align: center;
  padding: 0.5rem 1rem 1.25rem;
}
.Sidebar_sidebar__logo__qXaKw img {
  --size: 5.5rem;
  width: var(--size);
  height: var(--size);
  margin: 0 auto;
  object-fit: contain;
}
@media only screen and (max-width: 768px) {
  .Sidebar_sidebar__logo__qXaKw {
    padding-top: 1rem;
  }
}
.Sidebar_sidebar__menu__Adm5a {
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: column;
  flex-grow: 1;
  gap: 0.35rem;
  padding: 0 0.35rem;
}
.Sidebar_sidebar__menu__item__H9Vok {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  min-height: 44px;
  padding: 0.65rem 0.85rem;
  border-radius: 8px;
  transition: background-color 150ms cubic-bezier(0.16, 1, 0.3, 1), color 150ms cubic-bezier(0.16, 1, 0.3, 1);
  cursor: pointer;
}
.Sidebar_sidebar__menu__item__H9Vok:hover {
  background-color: var(--surface-muted);
  color: var(--primaryColor);
}
.Sidebar_sidebar__menu__item__H9Vok.Sidebar_active__UxjKV {
  font-weight: 700;
  color: var(--primaryColor);
  background-color: rgba(3, 105, 161, 0.1);
}
.Sidebar_sidebar__menu__item__H9Vok.Sidebar_active__UxjKV::before {
  content: "";
  width: 3px;
  height: 60%;
  background-color: var(--primaryColor);
  border-radius: 100vw;
  position: absolute;
  left: 0;
  top: 20%;
}
.Sidebar_sidebar__menu__item__icon__xs7gN {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.85rem;
  flex-shrink: 0;
}
.Sidebar_sidebar__menu__item__icon__xs7gN svg {
  width: 20px;
  height: 20px;
}
.Sidebar_sidebar__menu__item__txt__tPoyu {
  white-space: nowrap;
  font-size: 0.9375rem;
}

.Sidebar_logout__ePNPc {
  align-self: stretch;
  margin-top: auto;
  padding: 0.75rem 0.35rem 0.25rem;
  border-top: 1px solid var(--border-color);
}
.Sidebar_logout__ePNPc .Sidebar_sidebar__menu__item__H9Vok:hover {
  color: var(--destructive);
  background-color: var(--rejected-bgc);
}

html[dir=rtl] .Sidebar_sidebar__cTjr2 {
  border-right: none;
  border-left: 1px solid var(--border-color);
}
html[dir=rtl] .Sidebar_sidebar__menu__item__H9Vok.Sidebar_active__UxjKV::before {
  left: auto;
  right: 0;
}
html[dir=rtl] .Sidebar_sidebar__menu__item__icon__xs7gN {
  margin-right: 0;
  margin-left: 0.85rem;
}
html[dir=rtl] .Sidebar_sidebar__cTjr2.Sidebar_sidebar_close__VY5Y6 .Sidebar_sidebar__logo__qXaKw {
  direction: ltr;
  width: 46px;
  margin-right: 10px;
  overflow: hidden;
}
@media only screen and (max-width: 768px) {
  html[dir=rtl] .Sidebar_sidebar__cTjr2.Sidebar_sidebar_close__VY5Y6 .Sidebar_sidebar__logo__qXaKw {
    direction: rtl;
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/Sidebar.module.scss","webpack://./src/scss/abstracts/_variables.scss","webpack://./src/scss/abstracts/_mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,kBAAA;AAeA,mDAAA;AAIA,0BAAA;AAKA,sBAAA;AAIA,2BAAA;AAMA,8BAAA;AAOA,qBAAA;ADvCA;EECE,aAAA;EACA,oBFDc;EEEd,uBFFuB;EACvB,sBAAA;EACA,iCAAA;EACA,wBAAA;EACA,YC4BiB;ED3BjB,aAAA;EACA,eAAA;EACA,MAAA;EACA,2CAAA;EACA,oGAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;AASF;AAPE;EACE,WCiBgB;ADRpB;AEbE;EFGA;IAGI,WAAA;EAWJ;AACF;AElBE;EFbF;IAwBI,YAAA;IACA,UAAA;IACA,uCAAA;IACA,cAAA;IACA,kBAAA;EAWF;AACF;AATE;EACE,kBAAA;EACA,4BAAA;AAWJ;AATI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAWN;AEtCE;EFkBA;IAaI,iBAAA;EAWJ;AACF;AARE;EE/CA,aAAA;EACA,oBF+CgB;EE9ChB,2BF8CyB;EACvB,sBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAYJ;AAVI;EEtDF,aAAA;EACA,mBFsDkB;EErDlB,2BFqD0B;EACtB,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBC1Cc;ED2Cd,2GAAA;EACA,eAAA;AAcN;AAZM;EACE,sCAAA;EACA,0BAAA;AAcR;AAXM;EACE,gBAAA;EACA,0BAAA;EACA,wCAAA;AAaR;AAXQ;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AAaV;AATM;EErFJ,aAAA;EACA,mBFqFoB;EEpFpB,uBFoF4B;EACtB,qBAAA;EACA,cAAA;AAaR;AAXQ;EACE,WCrEM;EDsEN,YCtEM;ADmFhB;AAVM;EACE,mBAAA;EACA,oBAAA;AAYR;;AANA;EACE,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,yCAAA;AASF;AAPE;EACE,yBAAA;EACA,qCAAA;AASJ;;AAJE;EACE,kBAAA;EACA,0CAAA;AAOJ;AAHQ;EACE,UAAA;EACA,QAAA;AAKV;AAFQ;EACE,eAAA;EACA,oBAAA;AAIV;AAAI;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAEN;AE/HE;EFyHE;IAMI,cAAA;IACA,WAAA;EAIN;AACF","sourcesContent":["@use \"../../scss/abstracts/\" as *;\r\n\r\n.sidebar {\r\n  @include flex(stretch, center);\r\n  flex-direction: column;\r\n  background-color: var(--card-bgc);\r\n  color: var(--text-color);\r\n  width: $sideBarOpenWidth;\r\n  height: 100vh;\r\n  position: fixed;\r\n  top: 0;\r\n  border-right: 1px solid var(--border-color);\r\n  transition: width $duration-base $ease-out, transform $duration-base $ease-out;\r\n  z-index: 200;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding: 1.25rem 0.75rem;\r\n\r\n  &.sidebar_close {\r\n    width: $sideBarCloseWidth;\r\n    @include tablet {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  @include tablet {\r\n    width: 100vw;\r\n    z-index: 1;\r\n    background-color: var(--secondaryColor);\r\n    color: #f8fafc;\r\n    border-right: none;\r\n  }\r\n\r\n  &__logo {\r\n    text-align: center;\r\n    padding: 0.5rem 1rem 1.25rem;\r\n\r\n    img {\r\n      --size: 5.5rem;\r\n      width: var(--size);\r\n      height: var(--size);\r\n      margin: 0 auto;\r\n      object-fit: contain;\r\n    }\r\n\r\n    @include tablet {\r\n      padding-top: 1rem;\r\n    }\r\n  }\r\n\r\n  &__menu {\r\n    @include flex(stretch, flex-start);\r\n    flex-direction: column;\r\n    flex-grow: 1;\r\n    gap: 0.35rem;\r\n    padding: 0 0.35rem;\r\n\r\n    &__item {\r\n      @include flex(center, flex-start);\r\n      position: relative;\r\n      min-height: 44px;\r\n      padding: 0.65rem 0.85rem;\r\n      border-radius: $smallBorderRadius;\r\n      transition: background-color $duration-fast $ease-out, color $duration-fast $ease-out;\r\n      cursor: pointer;\r\n\r\n      &:hover {\r\n        background-color: var(--surface-muted);\r\n        color: var(--primaryColor);\r\n      }\r\n\r\n      &.active {\r\n        font-weight: 700;\r\n        color: var(--primaryColor);\r\n        background-color: rgba(3, 105, 161, 0.1);\r\n\r\n        &::before {\r\n          content: \"\";\r\n          width: 3px;\r\n          height: 60%;\r\n          background-color: var(--primaryColor);\r\n          border-radius: 100vw;\r\n          position: absolute;\r\n          left: 0;\r\n          top: 20%;\r\n        }\r\n      }\r\n\r\n      &__icon {\r\n        @include flex(center, center);\r\n        margin-right: 0.85rem;\r\n        flex-shrink: 0;\r\n\r\n        svg {\r\n          width: $smallIconSize;\r\n          height: $smallIconSize;\r\n        }\r\n      }\r\n      &__txt {\r\n        white-space: nowrap;\r\n        font-size: 0.9375rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.logout {\r\n  align-self: stretch;\r\n  margin-top: auto;\r\n  padding: 0.75rem 0.35rem 0.25rem;\r\n  border-top: 1px solid var(--border-color);\r\n\r\n  .sidebar__menu__item:hover {\r\n    color: var(--destructive);\r\n    background-color: var(--rejected-bgc);\r\n  }\r\n}\r\n\r\nhtml[dir=\"rtl\"] {\r\n  .sidebar {\r\n    border-right: none;\r\n    border-left: 1px solid var(--border-color);\r\n\r\n    &__menu {\r\n      &__item {\r\n        &.active::before {\r\n          left: auto;\r\n          right: 0;\r\n        }\r\n\r\n        &__icon {\r\n          margin-right: 0;\r\n          margin-left: 0.85rem;\r\n        }\r\n      }\r\n    }\r\n    &.sidebar_close .sidebar__logo {\r\n      direction: ltr;\r\n      width: 46px;\r\n      margin-right: 10px;\r\n      overflow: hidden;\r\n      @include tablet {\r\n        direction: rtl;\r\n        width: auto;\r\n      }\r\n    }\r\n  }\r\n}\r\n","/* ****Fonts**** */\r\n\r\n//Body size\r\n$fontSizeBodySmall: 12px;\r\n$fontSizeBodyMedium: 14px;\r\n$fontSizeBodyLarge: 16px;\r\n//Headline size\r\n$fontSizeHeadlineSmall: 24px;\r\n$fontSizeHeadlineMedium: 36px;\r\n$fontSizeHeadlineLarge: 48px;\r\n//Display size\r\n$fontSizeDisplaySmall: 56px;\r\n//helper font size\r\n$fontSizeTableStatus: 11px;\r\n\r\n/* ****Shadows (subtle elevation — flat SaaS)**** */\r\n$mainBoxShadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06);\r\n$secondBoxShadow: 0 12px 40px rgba(15, 23, 42, 0.18);\r\n\r\n/* ****Border radius**** */\r\n$smallBorderRadius: 8px;\r\n$mediumBorderRadius: 12px;\r\n$largeBorderRadius: 16px;\r\n\r\n/* ****icon size**** */\r\n$smallIconSize: 20px;\r\n$largeIconSize: 48px;\r\n\r\n/* **** Device width **** */\r\n$mobile-width: 576px;\r\n$tablet-width: 768px;\r\n$desktop-width: 992px;\r\n$largeDesktop-width: 1200px;\r\n\r\n/* **** helper variable **** */\r\n$sideBarOpenWidth: 248px;\r\n$sideBarCloseWidth: 72px;\r\n$spacing: 60px;\r\n$mobileSpacing: 16px;\r\n$sideBarLogoHeight: 171px;\r\n\r\n/* **** Motion **** */\r\n$ease-out: cubic-bezier(0.16, 1, 0.3, 1);\r\n$duration-fast: 150ms;\r\n$duration-base: 200ms;\r\n","@use './variables' as *;\r\n\r\n@mixin flex($alignItem: center, $justifyContent: center) {\r\n  display: flex;\r\n  align-items: $alignItem;\r\n  justify-content: $justifyContent;\r\n}\r\n\r\n@mixin mobile {\r\n  @media only screen and (max-width: $mobile-width) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin tablet {\r\n  @media only screen and (max-width: $tablet-width) {\r\n    @content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `Sidebar_sidebar__cTjr2`,
	"sidebar_close": `Sidebar_sidebar_close__VY5Y6`,
	"sidebar__logo": `Sidebar_sidebar__logo__qXaKw`,
	"sidebar__menu": `Sidebar_sidebar__menu__Adm5a`,
	"sidebar__menu__item": `Sidebar_sidebar__menu__item__H9Vok`,
	"active": `Sidebar_active__UxjKV`,
	"sidebar__menu__item__icon": `Sidebar_sidebar__menu__item__icon__xs7gN`,
	"sidebar__menu__item__txt": `Sidebar_sidebar__menu__item__txt__tPoyu`,
	"logout": `Sidebar_logout__ePNPc`
};
export default ___CSS_LOADER_EXPORT___;
